// Copyright (c) Docugami, Inc. All rights reserved.
import { SettingsActionTypes, SET_SETTINGS_PANEL_SHOWING } from "./types";

export function setSettingsPanelShowing(state: boolean): SettingsActionTypes
{
    return {
        type: SET_SETTINGS_PANEL_SHOWING,
        payload: state
    };
}
